import riFavicon from './assets/ri-favicon.png';
import riLogo from './assets/ri-logo.png';
import { setStyle } from './map/map.slice';
import MapStyle from './map/map-style';
import store from './store';

export interface ColourScheme {
  sarTint: string;
  areaTint: string;
  drawActive: string;
  drawInactive: string;
  drawStatic: string;
}

// interface ThemeItem {
//   image: string;
//   title: string;
//   icon: string;
//   mapboxStyle: string;
//   colourScheme: string;
// }

const riskIntelligenceColours: ColourScheme = {
  sarTint: '#007BB8',
  areaTint: '#203058',
  drawActive: '#3C5AA6',
  drawInactive: '#6D7DA6',
  drawStatic: '#404040',
};

export const colourScheme = riskIntelligenceColours;

const themeVariables = {
  image: riLogo,
  title: 'Risk Intelligence',
  icon: riFavicon,
  mapboxStyle: MapStyle.RISK_INTELLIGENCE,
};

export const getFromTheme = (
  key: keyof typeof themeVariables,
  fallback?: string
) => themeVariables[key] || fallback;

const updateFavicon = (icon: string) => {
  let favicon: HTMLLinkElement | null =
    document.querySelector("link[rel~='icon']");
  if (!favicon) {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(favicon);
  }
  favicon.href = icon;
};

export const setTheme = () => {
  const { title, mapboxStyle, icon } = themeVariables;

  document
    .querySelector('html')
    ?.setAttribute('data-theme', 'RISK_INTELLIGENCE');
  document.title = title;
  updateFavicon(icon);
  store.dispatch(setStyle(mapboxStyle));
};

export const getDefaultMapboxStyle = () => themeVariables.mapboxStyle;
